module.exports = __webpack_public_path__ + "img/model-image.e61e4d75.png";